/************
 * Model Class
 * File Name ...: agency-response.components.ts
 * Generated By : ianday on 11/6/23
 * Date ........: 11/6/23
 /************/
import {ValidationResult} from './validation-result';

export interface AgencyResponse {
    id: number | null;
    serviceRequestId: number| null;
    agencyId: number | null;
    responseDate: Date | null;
    amountProvided: number | null;
    statusReasonId: number | null;
    plannedCommitted: string | null;
    unitOfMeasure: string | null;
    operation: string | null;
}

export class AgencyResponse {
    constructor() {
        this.id = 0;
        this.serviceRequestId = 0;
        this.agencyId = 0;
        this.amountProvided = 0;
        this.statusReasonId = 0;
        this.plannedCommitted = '';
        this.unitOfMeasure = '';
    }

    public setNewAgencyResponseRecord(srId: number, agencyId: number, uom: string): AgencyResponse {
        this.serviceRequestId = srId;
        this.agencyId = agencyId;
        this.plannedCommitted = 'Committed';

        this.responseDate = new Date();
        this.unitOfMeasure = uom;

        return this;
    }
    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();
        return vr;
    }
}
